import React, { useState } from 'react';
import { SignupData, User } from '../types';

interface SignupFormProps {
  onSuccess: (user: User) => void;
  jobListingId?: string;
  actionType?: string;
}

const SignupForm: React.FC<SignupFormProps> = ({ 
  onSuccess, 
  jobListingId, 
  actionType 
}) => {
  const [formData, setFormData] = useState<SignupData>({
    email: '',
    password: '',
    password_confirmation: ''
  });
  const [errors, setErrors] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors([]);

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
      
      const response = await fetch('/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken || ''
        },
        body: JSON.stringify({
          user: formData,
          job_listing_id: jobListingId,
          action_type: actionType
        })
      });

      if (response.ok) {
        const userData = await response.json();
        onSuccess(userData.user);
      } else {
        const errorData = await response.json();
        setErrors(errorData.errors || ['登録に失敗しました']);
      }
    } catch (error) {
      setErrors(['ネットワークエラーが発生しました']);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      {errors.length > 0 && (
        <div className="alert alert-danger">
          {errors.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      )}

      <div className="mb-3">
        <label htmlFor="email" className="form-label">メールアドレス</label>
        <input
          type="email"
          className="form-control"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <div className="mb-3">
        <label htmlFor="password" className="form-label">パスワード</label>
        <input
          type="password"
          className="form-control"
          id="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
        />
      </div>

      <div className="mb-3">
        <label htmlFor="password_confirmation" className="form-label">パスワード（確認）</label>
        <input
          type="password"
          className="form-control"
          id="password_confirmation"
          name="password_confirmation"
          value={formData.password_confirmation}
          onChange={handleChange}
          required
        />
      </div>

      <button 
        type="submit" 
        className="btn btn-primary text-white w-100 mb-3"
        disabled={isLoading}
      >
        {isLoading ? '登録中...' : '新規登録'}
      </button>
      
      <div className="text-center text-muted small mb-3">
        アカウントの新規登録をするにあたりインディバースフリーランスの
        <a href="/terms" className="text-decoration-none">利用規約</a>及び
        <a href="/privacy" className="text-decoration-none">プライバシーポリシー</a>に同意したものとなります。
      </div>
    </form>
  );
};

export default SignupForm;
